<template>
  <div class="content-section col">
    <!-- <h1 class="header-content">Hej {{ user.name }}!</h1> -->
  </div>
</template>
